import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../context/Provider";
import { login } from "../../../global/context/action/auth/login";
import { useHistory, useLocation } from "react-router";
import { showModal, hideModal } from "../../context/Actions/modal/modal";
import { logoutApp } from "../../../global/context/action/auth/logoutApp";
import { GlobalContext } from "../../../global/context/Provider";
import Layout from "./LoginLayout";
import Loading from "../../components/Genericos/Loading/Loading";
import GetToken from "global/utils/getToken";
import { wsGetConfig } from "global/context/action/config/config";
import { showToaster } from "global/context/action/toaster/toaster";
import { getLocalStorage } from "global/utils/safeJsonParse";

const Login = () => {
  const history = useHistory();
  const { modalDispatch, resetPortalContext } = useContext(PortalContext);
  // Nuevo contexto
  const { authState, authDispatch, toasterDispatch } =
    useContext(GlobalContext);
  const search = useLocation().search;
  let idTerminal = getLocalStorage("idTerminal");
  const dataComplete = getLocalStorage("dataComplete", {});
  const [documentoError, setDocumentoError] = useState(false);
  const [form, setForm] = useState([
    {
      name: "nro_documento",
      value: "",
      inputType: "number",
      headerStr: "Ingresá tu número de documento",
      placeholderText: "12345678",
      errorStr: "El número de documento no es válido.",
      maxLength: "9",
      className: "inputNonScroll rb16m",
      checkError: documentoError,
      isRequired: true,
      inputMode: "numeric",
      pattern: "[0-9]*",
    },
  ]);
  const loginFormValid = form[0].value.length > 6;
  const [centro, setCentro] = useState(
    dataComplete?.idCentro && window.innerWidth >= 1024
      ? dataComplete.idCentro
      : "",
  );

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const irAlPortal = () => {
    if (window.innerWidth >= 1024) {
      dissmiss();
    } else {
      window.open("https://portal.dim.com.ar", "_blank");
    }
  };

  //Login y Cambios en el input Form
  const logueando = () => {
    let dto = {
      txtDni: form[0].value,
      tag: idTerminal ? idTerminal : "CHKQR",
    };
    // setFlgLogin(true);
    login(dto, ingresoApp)(authDispatch);
  };

  const onInputsChange = (e) => {
    const { name, value } = e.target;

    // Función auxiliar para actualizar un campo en form
    const updateFormField = (fieldName, fieldValue) => {
      setForm((prev) =>
        prev.map((item) =>
          item.name === fieldName ? { ...item, value: fieldValue } : item,
        ),
      );
    };

    if (name === "nro_documento") {
      // 1) Limpio sólo dígitos
      let cleaned = value.replace(/\D/g, "");

      // 2) Limito a 8 caracteres máximo
      if (cleaned.length > 8) {
        cleaned = cleaned.slice(0, 8);
      }

      // 3) Valido: debe ser 7 u 8 dígitos exactos
      const isValidDni = /^[0-9]{7,8}$/.test(cleaned);

      // 4) Actualizo el error y el formulario
      setDocumentoError(!isValidDni);
      updateFormField(name, cleaned);
    } else {
      // Para otros campos, simplemente guardo el valor crudo
      updateFormField(name, value);
    }
  };

  const ingresoApp = (isCorrect, data) => {
    if (isCorrect) {
      if (centro !== "") {
        history.push("/autocheckin");
      } else {
        // Primero limpiamos el contexto (resetPortalContext resetea modal a
        // initialState); después mostramos el modal para que el SHOW_MODAL
        // sea el último dispatch del batch y no lo pise el reset.
        logoutApp(history, resetPortalContext)(authDispatch);
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "No ingresa por QR",
            texto:
              "Le solicitamos que escanee el QR en el centro más cercano para comenzar su atención. También puede ingresar a portaldim.com.ar para obtener más información.",
            danger: true,
            dissmiss: dissmiss,
          },
          [
            {
              text: "Volver",
              clase: "btnAdjust b-latex30 bgc-white rb16m c-latex30",
              accion: dissmiss,
            },
            {
              text: "Ir al Portal",
              clase: "btnAdjust b-latex30 bgc-latex30 rb16m c-white",
              accion: irAlPortal,
            },
          ],
          "centro",
        )(modalDispatch);
      }
    } else {
      const tooManyReq = data?.detail?.status === 429;
      const bloqueado = data?.detail?.detail?.includes("bloqueado");
      
      // logoutApp primero para que el resetPortalContext no pise el modal.
      logoutApp(history, resetPortalContext)(authDispatch);
      showModal(
        "Genericos/Mensaje/Mensaje",
        {
          titulo:
            tooManyReq || bloqueado ? "Atención" : "Usuario no encontrado",
          texto: tooManyReq
            ? "Demasiados intentos. Por favor intentá nuevamente en unos minutos"
            : bloqueado
              ? data?.detail?.detail
              : "Aún no tenés una cuenta creada en el portal de turnos. Ingresá a portaldim.com.ar para registrarte.",
          danger: true,
          dissmiss: dissmiss,
        },
        [
          {
            text: "Volver",
            clase: "btnAdjust b-latex30 bgc-white rb16m c-latex30",
            accion: dissmiss,
          },
          !idTerminal && {
            text: "Ir al Portal",
            clase: "btnAdjust b-latex30 bgc-latex30 rb16m c-white",
            accion: irAlPortal,
          },
        ],
        "centro",
      )(modalDispatch);
    }
  };

  useEffect(() => {
    let token = GetToken(search);
    if (token) {
      const decoded = decodeToken(token);
      setCentro(decoded?.Sede);
      sessionStorage.setItem("centroID", decoded?.Sede);
    }
  }, []);

  // Este useEffect solo lo ejecuto en caso de que sea una terminal
  // no lo necesito en mobile
  useEffect(() => {
    // const isElectron = navigator.userAgent.toLowerCase().includes("electron");
    if (window.innerWidth >= 1024) {
      if (!idTerminal) {
        history.push("checkinConfig");
      } else {
        wsGetConfig(idTerminal, nextStepConfig);
      }
    } else {
      localStorage.removeItem("idTerminal");
    }
  }, []);

  const nextStepConfig = (isCorrect, data) => {
    if (isCorrect) {
      if (!isEqual(data, dataComplete)) {
        localStorage.setItem("dataComplete", JSON.stringify(data));
      }
      setCentro(data?.idCentro);
      sessionStorage.setItem("centroID", data?.idCentro);
    } else if (dataComplete?.idCentro) {
      // Fallback: si la llamada al backend falla pero tenemos config cacheado
      // de una sesión anterior, lo usamos para que el paciente pueda ingresar
      // (la terminal está siempre en el mismo centro físicamente).
      setCentro(dataComplete.idCentro);
      sessionStorage.setItem("centroID", dataComplete.idCentro);
      console.warn("[Login] wsGetConfig falló, usando dataComplete cacheado");
    } else {
      // setLoading(false);
      showToaster(
        {
          texto: data.detail,
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const isEqual = (obj1, obj2) => {
    if (obj1 === obj2) {
      return true;
    }
    if (
      typeof obj1 !== "object" ||
      obj1 === null ||
      typeof obj2 !== "object" ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (!keys2.includes(key) || !isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  };

  const decodeToken = (token) => {
    try {
      const payload = token.split(".")[1];
      const json = atob(payload);
      return JSON.parse(json);
    } catch (e) {
      console.error("Token inválido:", e);
      return null;
    }
  };

  return (
    <>
      <Loading
        dataLoading={authState.auth.loading}
        descripcion="Cargando..."
        color={"c-white"}
      />
      <Layout
        form={form}
        loading={authState.auth.loading}
        onChange={onInputsChange}
        onSubmit={logueando}
        error={authState.auth.error}
        loginFormValid={loginFormValid}
      />
    </>
  );
};

export default Login;
